import styled, { css } from "styled-components";
import { useRef } from "react";
import ProgressSignImg from "../img/ProgressSign.svg";
import { useSelector } from "react-redux";
import Guide from './Guide'

const TopFrame = styled.div`
  width: 100%;
`;

const TitleName = styled.div`
  font-size: 40px;
  text-align: left;
  margin-bottom: 30px;
  font-family: Gongim-Medium;
  color: #222;
  @media (max-width: 1099px) {
    font-size: 22px;
    margin-bottom: 16px;
  }
`;

const ProgressPC = styled.div`
  width: 100%;
  height: 64px;
  border: 1px solid #707070;
  border-radius: 8px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 40px;
  @media (max-width: 1099px) {
    height: 48px;
    margin-bottom: 20px;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

const ProgressName = styled.div`
  width: auto;
  color: #999999;
  font-size: 24px;
  font-family: Gongim-Medium;
  ${(props) =>
    props.titleColor &&
    css`
      color: #eb3f3d;
    `}
  @media (max-width: 1099px) {
    font-size: 16px;
  }
`;

const ProgressSign = styled.img`
  width: 10px;
`;

const ProgressMobile = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 36px;

  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileProBarFrame = styled.div`
  background-color: #dddddd;
  width: 100%;
  height: 7px;
  border-radius: 99px;
`;
const MobileProBar = styled.div`
  background-color: #349dec;
  height: 7px;
  border-radius: 99px;
`;

const MobileProBar00 = styled.div`
  width: 0%;
  background-color: #349dec;
  height: 7px;
  border-radius: 99px;
`;

const MobileProBar01 = styled.div`
  width: 25%;
  background-color: #349dec;
  height: 7px;
  border-radius: 99px;
`;

const MobileProBar02 = styled.div`
  width: 50%;
  background-color: #349dec;
  height: 7px;
  border-radius: 99px;
`;

const MobileProBar03 = styled.div`
  width: 75%;
  background-color: #349dec;
  height: 7px;
  border-radius: 99px;
`;

const MobileProBar04 = styled.div`
  width: 100%;
  background-color: #349dec;
  height: 7px;
  border-radius: 99px;
`;

const GuidePC = styled.div`
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
`;

const GuideMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`

export default function Top() {
  const inputRef = useRef();
  const pageCount = useSelector((state) => state.counter.data.pageCount)

  // if (State01 === true) {
  //   inputRef.current.style = "width: 25%";
  // } else if (State02 === true) {
  //   inputRef.current.style = "width: 50%";
  // } else if (State03 === true) {
  //   inputRef.current.style = "width: 75%";
  // } else if (State04 === true) {
  //   inputRef.current.style = "width: 100%";
  // }
  return (
    <TopFrame>
      {pageCount < 5 &&
        <>
          <TitleName>공임나라 딜리버리</TitleName>
          {pageCount === 1 &&
            <GuideMobile>
              <Guide />
            </GuideMobile>
          }
          <ProgressPC>
            <ProgressName titleColor={pageCount === 1}>01 주문 접수 정보</ProgressName>
            <ProgressSign src={ProgressSignImg} />
            <ProgressName titleColor={pageCount === 2}>02 출발지/도착지 입력</ProgressName>
            <ProgressSign src={ProgressSignImg} />
            <ProgressName titleColor={pageCount === 3}>03 결제 및 특이사항 입력</ProgressName>
            <ProgressSign src={ProgressSignImg} />
            <ProgressName titleColor={pageCount === 4}>04 주문 접수 완료</ProgressName>
          </ProgressPC>
          {pageCount === 1 &&
              <GuidePC>
                <Guide />
              </GuidePC>
          }
          <ProgressMobile>
            {pageCount === 1 && (
              <ProgressName titleColor={true}>01 주문 접수 정보</ProgressName>
            )}
            {pageCount === 2 && (
              <ProgressName titleColor={true}>02 출발지/도착지 입력</ProgressName>
            )}
            {pageCount === 3 && (
              <ProgressName titleColor={true}>03 결제 및 특이사항 입력</ProgressName>
            )}
            {pageCount === 4 && (
              <ProgressName titleColor={true}>04 주문 접수 완료</ProgressName>
            )}
            <MobileProBarFrame>
              {/* <MobileProBar ref={inputRef} /> */}
              {pageCount === 1 && <MobileProBar01 />}
              {pageCount === 2 && <MobileProBar02 />}
              {pageCount === 3 && <MobileProBar03 />}
              {pageCount === 4 && <MobileProBar04 />}
            </MobileProBarFrame>
          </ProgressMobile>
        </>
      }
      {pageCount >= 5 &&
        <>
          <TitleName>공임나라 딜리버리 예약현황</TitleName>
          <ProgressPC>
            <ProgressName titleColor={pageCount === 5}>01 주문 정보 확인</ProgressName>
            <ProgressSign src={ProgressSignImg} />
            <ProgressName titleColor={pageCount === 6}>02 기사 배정</ProgressName>
            <ProgressSign src={ProgressSignImg} />
            <ProgressName titleColor={pageCount === 7}>03 운행 완료</ProgressName>
            <ProgressSign src={ProgressSignImg} />
            <ProgressName titleColor={pageCount === 8}>04 결제 완료</ProgressName>
          </ProgressPC>
          <ProgressMobile>
            {pageCount === 5 && (
              <ProgressName titleColor={true}>01 주문 정보 확인</ProgressName>
            )}
            {pageCount === 6 && (
              <ProgressName titleColor={true}>02 기사 배정</ProgressName>
            )}
            {pageCount === 7 && (
              <ProgressName titleColor={true}>03 운행 완료</ProgressName>
            )}
            {pageCount === 8 && (
              <ProgressName titleColor={true}>04 결제 완료</ProgressName>
            )}
            {pageCount === 99 && (
              <ProgressName titleColor={true}>* 주문 취소</ProgressName>
            )}
            <MobileProBarFrame>
              {/* <MobileProBar ref={inputRef} /> */}
              {pageCount === 5 && <MobileProBar01 />}
              {pageCount === 6 && <MobileProBar02 />}
              {pageCount === 7 && <MobileProBar03 />}
              {pageCount === 8 && <MobileProBar04 />}
              {pageCount === 99 && <MobileProBar00 />}
            </MobileProBarFrame>
          </ProgressMobile>
        </>
      }
    </TopFrame>
  );
}
